import { Navigation } from '@/components/Navigation';
import { MasonryContent } from '@/components/MasonryContent';
import { Footer } from '@/components/Footer';
import { AudioController } from '@/components/AudioController';
import { UnrealPressFlash } from '@/components/UnrealPressFlash';

export const HomePage = () => {
  return (
    <div className="relative min-h-screen bg-background noise-texture wire-grid">
      {/* CRT screen effect overlay */}
      <div className="fixed inset-0 pointer-events-none crt-scanlines z-40" />
      
      <AudioController />
      <UnrealPressFlash />
      <Navigation />
      <main>
        <MasonryContent />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;